// extracted by mini-css-extract-plugin
export default {"leitor":"LeitorDePdf_leitor__9fHrQ","paginas":"LeitorDePdf_paginas__Gkx0u","pagina":"LeitorDePdf_pagina__hUk+w","andamento":"LeitorDePdf_andamento__lNV1n"};